import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import SITE from '../data/site';
import logo from '../assets/logo/logo.png';

export default function Header() {
  const [open, setOpen] = useState(false);
  const nav = useNavigate();
  const { clinic, services } = SITE;

  return (
    <>
      <header className="header">
        <div className="container header-inner">
          <div className="logo" onClick={() => nav('/')}>
            {clinic.logo
              ? <img src={logo} className="logo-img" alt={clinic.name} onError={e => e.target.style.display='none'} />
              : <div className="logo-fallback">🦷</div>
            }
            <div className="logo-text">{clinic.name}<small>{clinic.nameEn}</small></div>
          </div>

          <nav className="nav">
            <Link className="nav-link" to="/">الرئيسية</Link>
            <Link className="nav-link" to="/about">من نحن</Link>
            <div className="nav-dd">
              <span className="nav-dd-trigger">خدماتنا</span>
              <div className="nav-drop">
                {services.map(s => (
                  <Link key={s.id} className="nav-drop-link" to={`/services/${s.id}`}>{s.icon} {s.title}</Link>
                ))}
              </div>
            </div>
            <Link className="nav-link" to="/contact">تواصل معنا</Link>
            <a className="btn btn-gold" href={clinic.whatsapp} target="_blank" rel="noreferrer" style={{ padding: '9px 18px', fontSize: '.83rem' }}>✦ احجز موعد</a>
          </nav>

          <div className={`hamburger${open ? ' open' : ''}`} onClick={() => setOpen(o => !o)}>
            <span /><span /><span />
          </div>
        </div>
      </header>

      <div className={`mob-nav${open ? ' open' : ''}`}>
        {[['/', 'الرئيسية'], ['/about', 'من نحن'], ['/contact', 'تواصل معنا']].map(([path, label]) => (
          <Link key={path} className="mob-nav-link" to={path} onClick={() => setOpen(false)}>{label}</Link>
        ))}
        <span className="mob-nav-link" style={{ color: 'rgba(201,168,76,.6)', fontSize: '.78rem', paddingTop: 14 }}>خدماتنا</span>
        <div className="mob-sub">
          {services.map(s => (
            <Link key={s.id} className="mob-nav-link" to={`/services/${s.id}`} onClick={() => setOpen(false)}>{s.icon} {s.title}</Link>
          ))}
        </div>
        <a className="mob-nav-link" href={clinic.whatsapp} target="_blank" rel="noreferrer" style={{ color: '#25D366', fontWeight: 700 }}>💬 واتساب</a>
      </div>

      {/* Float buttons */}
      <div className="floats">
        <a className="fl-btn fl-phone" href={`tel:${clinic.phone}`}>📞</a>
        <a className="fl-btn fl-wa" href={clinic.whatsapp} target="_blank" rel="noreferrer">💬</a>
      </div>
    </>
  );
}
